import { Pipe, PipeTransform } from '@angular/core';
import { DateTime } from 'luxon';

@Pipe({
  name: 'relativeDate'
})
export class RelativeDatePipe implements PipeTransform {

  transform(value: DateTime, args?: any[]): string {    
    const diff = DateTime.local().diff(value, 'minutes');
    const minutes = Math.round(diff.minutes);
    if (diff.minutes < 1)
      return $localize`Nu`;
    else if (diff.minutes < 60)
      return $localize`${minutes} minuter sen`;
    else if (value.hasSame(DateTime.utc(), 'day'))
      return value.toFormat('HH:mm');
    else if (value.hasSame(DateTime.utc().minus({ hours: 24 }), 'day')) {
      const time = value.toFormat('HH:mm');
      return $localize`Igår ${time}`;
    }
    else if (diff.minutes < 475200)
      return value.toFormat('d LLL HH:mm');
    return value.toFormat('yyyy-LL-dd');
  }

}
